import type { GridProps } from '@chakra-ui/react'
import { Grid } from '@chakra-ui/react'
import React from 'react'

export interface FormBodyProps extends GridProps {
  children: React.ReactNode
}

export const FormBody = ({ children, sx, ...rest }: FormBodyProps) => {
  return (
    <Grid
      sx={{ alignItems: 'start', justifyItems: 'stretch', gap: 12, ...sx }}
      {...rest}
    >
      {children}
    </Grid>
  )
}
